import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { EmployeeCategoryComponent } from './employee-category/employee-category.component';
import { StaffUploadComponent } from './staff-upload/staff-upload.component';
import { StaffProfileComponent } from './staff-profile/staff-profile.component';
import { StaffDetailsComponent } from './staff-details/staff-details.component';
import { RollNumberGenerationComponent } from './roll-number-generation/roll-number-generation.component';
import { StaffIdCardComponent } from './staff-id-card/staff-id-card.component';
import { PrintStaffIdCardComponent } from './print-staff-id-card/print-staff-id-card.component';



const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
       { path: 'employeecategory', component: EmployeeCategoryComponent, pathMatch: 'full' },
       { path: 'staffupload', component: StaffUploadComponent, pathMatch: 'full' },
       { path: 'staffprofile', component: StaffProfileComponent, pathMatch: 'full' },
       { path: 'staffdetails', component: StaffDetailsComponent, pathMatch: 'full' },
       { path: 'rollnumbergeneration', component: RollNumberGenerationComponent, pathMatch: 'full' },
       { path: 'staffidcard', component: StaffIdCardComponent, pathMatch: 'full' },
     


    ]
  }
  ,
  {
    path: '',
    
    children: [
    
      { path: 'printstaffidcard', component: PrintStaffIdCardComponent, pathMatch: 'full' },
     ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StaffRoutingModule { }
